import { forwardRef, useImperativeHandle, useLayoutEffect, useRef } from 'react';
import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'style'> & { invalid?: boolean };
export type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'style'> & { invalid?: boolean };
export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'style'> & { invalid?: boolean };
export type CheckboxProps = Omit<InputProps, 'type'> & { indeterminate?: boolean };

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ invalid, className, ...props }, ref) {
  return <input {...props} ref={ref} className={`ui-control ${className ?? ''}`}
    aria-invalid={invalid || props['aria-invalid'] || undefined} />;
});
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select({ invalid, className, ...props }, ref) {
  return <select {...props} ref={ref} className={`ui-control ${className ?? ''}`}
    aria-invalid={invalid || props['aria-invalid'] || undefined} />;
});
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea({ invalid, className, ...props }, ref) {
  return <textarea {...props} ref={ref} className={`ui-control ui-textarea ${className ?? ''}`}
    aria-invalid={invalid || props['aria-invalid'] || undefined} />;
});
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { indeterminate = false, invalid, className, ...props }, ref,
) {
  const control = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => control.current!);
  useLayoutEffect(() => { if (control.current) control.current.indeterminate = indeterminate; }, [indeterminate]);
  return <input {...props} type="checkbox" ref={control} className={`ui-checkbox ${className ?? ''}`}
    aria-checked={indeterminate ? 'mixed' : props['aria-checked']}
    aria-invalid={invalid || props['aria-invalid'] || undefined} />;
});
